<template>
  <div
    v-show="content.message || messageFromDOM"
    :id="content.idHTML"
    :class="[
      jel_getClassObject(content),
      content.msgType ? 'mel-' + content.msgType : 'mel-erreur',
      { 'mel-titre': content.titre },
    ]"
    class="mt-md-2"
  >
    <div
      class="d-flex mb-0"
      :class="content.msgType ? 'mel-' + content.msgType + '-inner' : 'mel-erreur-inner'"
    >
      <div
        :class="
          content.msgType ? 'cercle' + capitalizeFirstLetter(content.msgType) : 'cercleErreur'
        "
      >
        <span
          :class="
            content.msgType
              ? 'cercle' + capitalizeFirstLetter(content.msgType) + '-contenu'
              : 'cercleErreur-contenu'
          "
          v-html="cercleErreurContenu"
        />
      </div>
      <div class="ml-1">
        <p v-if="content.titre" class="font-weight-bold pt-0 mb-4px" v-html="content.titre" />
        <span
          :id="content.idHTMLContenu"
          :class="content.msgType ? 'message-' + content.msgType : 'message-erreur'"
          v-html="content.message"
        />
      </div>
    </div>
  </div>
</template>

<script>
// Utilisé pour afficher les messages de lq-entete-connexion (MEL)
// Et autres messages simples
export default {
  name: 'MessageMel',
  // content est {idHTML, idHTMLContenu} ou {message}
  props: { content: { type: Object, required: true } },
  data() {
    return {
      messageFromDOM: '',
    };
  },
  computed: {
    cercleErreurContenu() {
      switch (this.content.msgType) {
        case 'succes':
          return '&#10003;';
        case 'info':
          return 'i';
        default:
          return '!';
      }
    },
  },
  mounted() {
    if (!this.content.idHTMLContenu) {
      this.messageFromDOM = this.content.message;
    } else {
      const messageErreur = document.getElementById(this.content.idHTMLContenu);
      const self = this;
      messageErreur.addEventListener(
        'DOMSubtreeModified',
        function () {
          self.messageFromDOM = messageErreur.textContent;
        },
        false
      );
    }
  },
  methods: {
    capitalizeFirstLetter(string) {
      return string[0].toUpperCase() + string.slice(1);
    },
  },
};
</script>

<style lang="scss">
.ehide {
  display: none !important;
}
.eshow {
  display: block;
}

.mel-erreur,
.mel-succes,
.mel-avertissement,
.mel-info {
  @media screen and (max-width: 767px) {
    padding: 1em 0;
  }
  @media screen and (min-width: 768px) {
    margin: 0 0 1em !important;
    max-width: none;
  }
}

.mel-titre {
  border-radius: 6px;
  padding: 12px;
  &.mel-info {
    background-color: #e5e6ff;
  }
  p:last-child {
    margin-bottom: 0;
  }
}
</style>
